import { type GlobalShortcutLinkItem } from '../../types';
import { getFallbackUrlMaybe } from '../get-fallback-url-maybe';

type Options = Pick<GlobalShortcutLinkItem, 'url' | 'fallbackUrl'>;

/**
 * Utility function that takes an object with `url` or `fallbackUrl` properties
 * and returns the first URL that isn't falsy, or the last.
 *
 * This function prioritizes the `url` property over `fallbackUrl`. If `url` is
 * truthy, it will be returned immediately. If `url` is falsy, the function will
 * attempt to resolve the `fallbackUrl`.
 *
 * @param {Options} options - Object containing `url` and/or `fallbackUrl` properties
 * @param {string} [options.url] - Direct URL string (takes priority)
 * @param {FallbackUrl} [options.fallbackUrl] - Fallback URL (string or function that returns string)
 * @returns {string | undefined} The first truthy URL, or the last URL (truthy or not)
 */
export const getUrlMaybe = (options: Options): string | undefined =>
	options.url || getFallbackUrlMaybe(options.fallbackUrl);
